angular.module('rentalListingModule').component('rentalListing', {
	templateUrl: 'rentalListing/rentalListing.html',
	transclude: true,
	bindings: {
		companyPhone: '@',
		termsOfUseUrl: '@',
		privacyPolicyUrl: '@',
		buildingSearchRpc: '@',
		brokerSearchRpc: '@',
		loginRpc: '@',
		submitRpc: '@',
		isEmailExistRpc: '@',
		is3rdPartyAccountExistRpc: '@',
		registrationSignUpRpc: '@',
		emailUsRpc: '@',
		isMobile: '<',
		forAddListing: '<',
		allowToAddNewListing: '<',
		forgotLinkUrl: '@',
		myListingsUrl: '@',
		imageSrc: '@',
		userName: '@',
		userPhoneNumber: '@',
		userIsBroker: '<',
		uploadRpc: '@',
		popupName: '@',
		missingImageSrc: '@',
		trackName: '@',
		maxPrice: '@',
		minPrice: '@',
		maxSqft: '@',
		minSqft: '@',
		uploadImageLimit: '<',
		limitListings: '<',
		rpcRegistrationEmailValidation: '@',
		userType: '@'
	},
	controller: ['$element', '$http', '$timeout', 'PubSub', 'fbService', 'handleNoReloadPageService', '$filter', 'crResourcesService', function($element, $http, $timeout, PubSub, fbService, handleNoReloadPageService, $filter, crResourcesService) {
		var ctrl = this;
		this.activeForm = null;
		this.$wrapper = $element[0].querySelector('.cmp-rental-listing-content-wrapper');
		this.htmlElement = angular.element(document.querySelector('html'));
		this.currentAddListingSteps = null;
		this.listing = {};
		this.user = {};
		this.fbUser = {};
		this.googleUser = {};
		this.fbError = false;
		this.unitList = null;
		this.steps = {
			abandoned: -1,
			initial: 0,
			addListing: 1,
			editListing: 2,
			successMessage: 3,
			limitMessage: 4
		};

		this.errorMessages = {
			required: 'This field is required.',
			requiredBuilding: 'Building is required.',
			requiredUnit: 'Unit is required.',
			requiredBedrooms: 'Bedroom is required.',
			requiredBathrooms: 'Bathroom is required.',
			requiredDescription: 'Description is required.',
			requiredPrice: 'Price is required.',
			requiredAgent: 'Agent Name is required.',
			email: 'Invalid Email.',
			emailExist: 'This email already exists.',
			emailBroker: 'This email is not a broker email.',
			phoneExist: 'This phone already exists.',
			phoneFormat: 'Are you sure this is correct? This is not a valid phone number.',
			phoneShort: 'This phone is too short (less than 6 characters).',
			minlength: 'Password can\'t be shorter than 6 characters.',
			maxlength: 'Password can\'t be longer than 64 characters.',
			notFullname: 'Please enter a full name.',
			generic: 'Error, please contact us for further assistance.',
			priceFormat: 'This price is not valid.',
			priceMaxLimit: 'Price can\'t be more than ' + $filter('formatBudget')(this.maxPrice, '$'),
			priceMinLimit: 'Price can\'t be less than ' + $filter('formatBudget')(this.minPrice, '$'),
			sqftMaxLimit: 'Sqft can\'t be more than ' + $filter('formatBudget')(this.maxSqft, ''),
			sqftMinLimit: 'Sqft can\'t be less than ' + $filter('formatBudget')(this.minSqft, ''),
			sqftFormat: 'This sqft is not valid.',
			confirmation: 'Please confirm that there are no fees associated with this listing.',
			fbError: 'Login error. Contact us for further assistance.',
			unitExist: 'This unit already exists.',
			requiredInquiriesPreference: 'How you would like to receive listing inquiries?'
		};

		this.getCurrentStepName = function(stepNumber) {
			var name = null;
			angular.forEach(this.steps, function(step, i){
				if (step == stepNumber) {
					name = i;
					return false;
				}
			});

			return name;
		};

		this.clickNext = function(to) {
			this.previousStep = this.activeStep;
			this.activeStep = to;
		};

		this.clickPrevious = function(from) {
			this.activeStep = from;
		};

		this.showSuccessMessage = function() {
			this.activeStep = this.steps.successMessage;
			PubSub.publish('cr-popup-success-message-' + this.popupName);
		};

		this.submit = function(form, type, fromFB, googleUser) {
			if (this.submitInProgress) {
				return;
			}

			if (googleUser) {
				this.googleUser = googleUser;
			}

			var url;
			var fromLogin = false;

			if (type === 'login' || type === 'emailRequest') {
				this.formData = {};
				fromLogin = true;

				// user already registered using FB acount before.
				if (type === 'login' && fromFB) {
					url = this.registrationSignUpRpc;
					this.formData.fb = this.fbUser;
				} else if (type === "login" && googleUser) {
					url = this.registrationSignUpRpc;
					this.formData.google = googleUser;
				} else if (type === 'emailRequest') {
					// this is for the user who try to login by facebook for the first time and
					// email doesnt exist from FB Data so we need to verify the email that the user provided
					url = this.isEmailExistRpc;

					var fromEmailRequest = true;
					this.formData.email = this.fbUser.userInfo.email;
					if (this.fbUser.userInfo.phone) {
						this.formData.phone = this.fbUser.userInfo.phone;
					}
					this.formData.type = "FB";

				} else {
					// regular cr login
					url = this.loginRpc;
					this.formData = this.user;
				}
			} else {
				url = this.submitRpc;

				this.formData = {
					listing: this.listing
				};
				if (this.fbUser && this.fbUser.userInfo) {
					this.formData.user = {
						fb: this.fbUser
					}
				} else if (this.googleUser && this.googleUser.id_token) {
					this.formData.user = {
						google: this.googleUser
					}
				} else if (this.isLoggedIn) {
					// only send this if the user is logged in and if the listing is not exclusive to agent.
					if (!this.listing.exclusiveToAgent) {
						this.formData.user = {
							phone: this.user.phone,
							sendInquiriesBy: this.user.sendInquiriesBy
						}
					}
				} else {
					this.formData.user = this.user;
				}
			}

			if (url) {
				if (form) {
					// Init global errors array
					form.globalErrors = [];
				}

				this.submitInProgress = true;
				$http({
					method: 'post',
					url: url,
					data: this.formData,
					headers: {'X-Requested-With': 'XMLHttpRequest'}
				})
				.success(function(data, status, headers, config) {
					if (data.data && data.data.status === false) {
						ctrl.handleErrors(form, data, fromLogin);
					} else {
						PubSub.publish('rental-listing-change-listing-list');
						if (fromFB && fromLogin) {
							ctrl.handleSuccess(ctrl.fbUser, fromLogin, fromFB, fromEmailRequest);
						} else {
							ctrl.handleSuccess(data, fromLogin);
						}
					}
					ctrl.submitInProgress = false;
				})
				.error(function(data, status, headers, config) {
					// other global error
					ctrl.handleGenericError(form, []);
					ctrl.submitInProgress = false;
				});
			}
		};

		this.handleSuccess = function(data, fromLogin, fromFB, fromEmailRequest) {
			if (fromLogin) {
				var user;

				if (data.userInfo && fromFB) {
					// for facebook login
					user = data.userInfo;
					this.user.name = user.first_name + ' ' + user.last_name;

					if (!fromEmailRequest) {
						// track when the user logged in
						// this is for FB account that is registered already in the database
						this.trackStep('fb-signin');
						this.handleNoReloadPage(true);
					}
				} else if (data.data && data.data.usr) {
					user = data.data.usr;
					this.user.name = user.firstName + ' ' + user.lastName;

					// track when the user logged in
					this.trackStep('signin');
					this.handleNoReloadPage(true);
				}

				// NCR-6671 : if the user choose to hide the unit of the listing but logged in after as a broker, set addressHidden to false
				if (data.data && data.data.isBroker) {
					this.listing.addressHidden = false;
					this.user.isBroker = true;
				}

				this.user.email = user.email;
				this.user.phone = user.phone;
				this.isLoggedIn = true;
			} else { // for registration and add the listing
				// NCR-4668, For Queue tracking
				if (data.data.trackQueue) {
					var trackQueue = data.data.trackQueue;
					crTrackerQueue.track(trackQueue);
				}

				// to set if the user is still allow to add more listing.
				// limit is 5 per user
				if (data.data.listing) {
					this.allowToAddNewListing = data.data.listing.next;
					this.listingUrl = data.data.listing.url;

					if (data.data.listing.pending) {
						this.listing.pending = data.data.listing.pending;
					}
				}

				if (data.data.object) {
					PubSub.publish('my-listings-set-newly-added-listing', data.data.object);
				}

				this.showSuccessMessage();

				if (this.forAddListing) {
					this.trackStep('create-listing');
				} else {
					this.trackStep('edit-listing');
				}
				this.trackRegistration(data);
			}
		};

		this.handleErrors = function(form, data, fromLogin) {
			var errors = data.data.form;

			// array means errors is an emty array. if theres error in the formListing backend returns it as object.
			if (Object.keys(errors).length === 0 && data.data.formListing) {
				errors = data.data.formListing;
			}

			// on rental-listing rpc if the registration is successful but the add listing is failed,
			// we still need to track when the registration is success
			if (!fromLogin) {
				this.trackRegistration(data);
			}

			if (Object.keys(errors).length) {
				angular.forEach(errors, function(error, key) {
					if (key !== 'FORMSUMMARY') {
						// There is no flag to determine what type of error we got from BED
						if (form[key]) {
							if (error[0]) {
								// duplicated error
								if (error[0].indexOf('already exist') > 0 || error[0].indexOf('already in use') > 0 ) {
									form[key].$setValidity(key + 'Exist', false);
								} else if (error[0].indexOf('too short') > 0) { // phone too short
									form[key].$setValidity(key + 'Short', false);
								} else if (error[0].indexOf('incorrect') > 0) { // twilio phone error
									form[key].$setValidity('pattern', false);
								} else if (error[0].indexOf('broker') > 0) { // broker domain error
									form[key].$setValidity(key + 'Broker', false);
								} else { // other global error
									ctrl.handleGenericError(form, error, key);
								}
							}
						} else {
							// other global error
							ctrl.handleGenericError(form, error, key);
						}
					}
				});
			} else {
				if (data.data.message.indexOf('reached the maximum') > 0) {
					this.activeStep = this.steps.limitMessage;
					this.allowToAddNewListing = false;
				} else {
					this.handleGenericError(form, [data.data.message]);
				}
			}
		};

		this.handleGenericError = function(form, error, key) {
			// we just keep one global error with a generic message
			if (form.globalErrors) {
				var gError = {};
				gError.key = key;
				gError.value = error[0] || this.errorMessages.generic;
				form.globalErrors.push(gError);

				// show login form when we get a login error after the user sign out in another tab
				if (key === 'login') {
					PubSub.publish('rental-listing-add-listing-show-login');
				}
			}
		};

		this.handleNoReloadPage = function(showTooltip) {
			handleNoReloadPageService.run(showTooltip);
		};

		this.fieldChange = function(form, key) {
			if (!form || !key) {
				return;
			}

			// if the form is not valid then remove the backend error associated to the field
			if (!form[key].$valid) {
				form[key].$setValidity(key + 'Exist', true);
				form[key].$setValidity(key + 'Global', true);
				form[key].$setValidity(key + 'Short', true);
				form[key].$setValidity(key + 'Broker', true);
			}
			// reset global errors
			if (form.globalErrors && form.globalErrors.length > 0) {
				form.globalErrors = [];
			}
		};

		this.trackStep = function(action) {
			if (this.trackName) {
				//console.log('Add Rental Listing', this.trackName, action);
				_gaq.push(['_trackEvent', 'Add Rental Listing', this.trackName, action]);
			}
		};

		this.trackRegistration = function(data) {
			// track when user created an account
			if (data.data.usr) {
				if (data.data.usr.FBUserWhoWasAlreadyRegistered) {
					this.trackStep('new-facebook-registration');
				} else if(data.data.usr.GoogleUserWhoWasAlreadyRegistered) {
					this.trackStep('new-google-registration');
				} else {
					this.trackStep('new-registration');
				}

				this.isLoggedIn = true;
				this.handleNoReloadPage(true);
			}
		};

		this.setUserState = function() {
			this.user.name = this.userName;
			this.user.phone = this.userPhoneNumber;
			this.setUserAsBroker(this.userIsBroker);
			this.isLoggedIn = !!this.user.name;
		};
		// list of units of the selected building
		this.updateUnitList = function(list) {
			this.unitList = list;
		};

		this.$postLink = function() {
			var $config = angular.element(document.querySelector('.cmp-rental-listing .config'));
			this.config = angular.fromJson($config.text());
			this.filters = this.config.filters;
			// set user state if log in or not
			ctrl.setUserState();
			this.activeStep = this.allowToAddNewListing ? ctrl.steps.initial : ctrl.steps.limitMessage;

			// TODO: REMOVE DEBUG
			// this.activeStep = ctrl.steps.addListing;
			// this.activeStep = ctrl.steps.editListing;
		};

		this.editListing = function(listing) {
			ctrl.listing = angular.copy(listing);
			ctrl.setUser(listing);
			ctrl.setFilters();
			ctrl.activeStep = ctrl.steps.editListing;
			ctrl.prevStep = ctrl.activeStep;
			ctrl.forAddListing = false;
			PubSub.publish('cr-popup-open-' + ctrl.popupName);
		};

		this.setUser = function(listing) {
			this.user.sendInquiriesBy = listing.send_inquiries_by;
			this.user.phone = listing.send_inquiries_phone;
		};

		this.addListing = function(skipInitialStep) {
			var firstStep = skipInitialStep ? ctrl.steps.addListing : ctrl.steps.initial;
			ctrl.activeStep = ctrl.allowToAddNewListing ? firstStep : ctrl.steps.limitMessage;
			ctrl.prevStep = ctrl.activeStep;
			ctrl.forAddListing = true;

			PubSub.publish('cr-popup-open-' + ctrl.popupName);
		};

		this.setFilters = function() {
			if (this.filters.bedroomsAll) {
				angular.forEach(this.filters.bedroomsAll.options, function(option) {
					if (option.value == ctrl.listing.beds) {
						option.active = true;
					} else {
						option.active = false;
					}
				});
			}
			if (this.filters.bathrooms) {
				angular.forEach(this.filters.bathrooms.options, function(option) {
					if (option.value == ctrl.listing.baths) {
						option.active = true;
					} else {
						option.active = false;
					}
				});
			}
			if (this.filters.freeRent) {
				angular.forEach(this.filters.freeRent.options, function(option) {
					if (option.value == ctrl.listing.freeRent) {
						option.active = true;
					} else {
						option.active = false;
					}
				});
			}
			PubSub.publish('resetDropdownFilter', this.filters);
		};

		this.clearForm = function(form) {
			var inputs = angular.element(document.querySelectorAll('.cmp-rental-listing input[type=text]'));

			angular.forEach(inputs, function(input) {
				input.value = null;

				if (form) {
					if (input.id === 'form-sqft' && form.sqft) {
						form.sqft.$setValidity('minLimit', true);
						form.sqft.$setValidity('maxLimit', true);
						form.sqft.$setUntouched();
					} else if (input.id === 'form-price' && form.price) {
						form.price.$setValidity('minLimit', true);
						form.price.$setValidity('maxLimit', true);
						form.price.$setUntouched();
					}
				}
			})

			this.listing = {};

			PubSub.publish('resetDropdownFilter');
			PubSub.publish('resetLimousine-building');
			PubSub.publish('resetLimousine-unit');
			PubSub.publish('resetLimousine-agent');

			this.currentAddListingSteps = null;

			if (this.isMobile) {
				this.scrollTo($element[0].getBoundingClientRect().top);
			}
		};

		this.scrollTo = function(val) {
			PubSub.publish('cr-popup-scroll-to-top-' + ctrl.popupName, val);
		};

		this.scrollToError = function() {
			// scroll to first error message
			$timeout(function() {
				var $firstInvalid = angular.element($element[0].querySelector('.error-msg'))[0].previousElementSibling;
				var offsetTop = $firstInvalid.getBoundingClientRect().top;
				ctrl.scrollTo(offsetTop);
			});
		};

		this.saveCurrentAddListingStep = function(step) {
			this.currentAddListingSteps = step;
		};

		this.setPopupState = function() {
			ctrl.isOpened = !ctrl.isOpened;

			// clear the Form when user close the success message
			if (!ctrl.isOpened) {
				ctrl.clearForm();
				ctrl.activeStep = ctrl.allowToAddNewListing ? ctrl.steps.initial : ctrl.steps.limitMessage;
			}
		};

		this.closePopup = function() {
			PubSub.publish('cr-popup-close-' + this.popupName);

			// track if the user close the popup without finishing the procedure.
			this.trackStep('abandon');

			// need some delay fot the user not to see the initial popup while the close event is not finish
			$timeout(function() {
				ctrl.clearForm();
				ctrl.activeStep = ctrl.steps.initial;
			});
		};

		this.continuePopup = function() {
			PubSub.publish('cr-popup-continue-' + this.popupName);
		};

		this.abandonedPopup = function() {
			ctrl.clickNext(ctrl.steps.abandoned);
		};

		this.showLimitMessage = function() {
			ctrl.allowToAddNewListing = false;
			ctrl.activeStep = ctrl.steps.limitMessage;
			PubSub.publish('cr-popup-open-' + ctrl.popupName);
		};

		this.setUserAsBroker = function(isBroker) {
			ctrl.user.isBroker = isBroker;
		};

		this.allowUserToAddNewListing =  function() {
			ctrl.allowToAddNewListing = true;
		};

		this.validateEmail = function(email, form) {
			var ctrl = this;
			var data = {
				email: email
			};

			this.validateEmailRpc = crResourcesService.post2(this.rpcRegistrationEmailValidation, data);
			this.validateEmailRpc.$promise.then(function(response) {
				if (response.data.status === false) {
					ctrl.handleErrors(form, response);
				} else {
					ctrl.user.isBrokerEmail = response.data.isBroker;
					// status true but broker false
					if (ctrl.user.isBroker && !ctrl.user.isBrokerEmail) {
						response.data.form = {
							FORMSUMMARY: [
								{
									message: 'Please fix the following errors:',
									status: false
								}
							],
							email: [
								'This is not a broker email.' // replaced by error messages
							]
						};
						ctrl.handleErrors(form, response);
					} else {
						// success
					}
				}
			}, function(response) {
				// other global error
				ctrl.handleGenericError(form);
			});
		};

		PubSub.subscribe('rental-listing-add-listing', this.addListing);
		PubSub.subscribe('rental-listing-edit-listing', this.editListing);
		PubSub.subscribe('cr-popup-abandoned-' + this.popupName, this.abandonedPopup);
		PubSub.subscribe('cr-popup-update-state-' + this.popupName, this.setPopupState);
		PubSub.subscribe('rental-listing-show-limit-message', this.showLimitMessage);
		PubSub.subscribe('rental-listing-allow-user-to-add-listing', this.allowUserToAddNewListing);
		PubSub.subscribe('user-is-broker', function() {
			ctrl.setUserAsBroker(true);
		});
		PubSub.subscribe('user-is-not-broker', function() {
			ctrl.setUserAsBroker(false);
		});
	}]
});
